import * as React from "react";

function SvgYoutubeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
      <circle cx={20} cy={20} r={20} fill="#d20023" />
      <path
        d="M30.667 13.648a2.327 2.327 0 00-1.493-1.29 54.924 54.924 0 00-18.348 0 2.327 2.327 0 00-1.493 1.29 17.62 17.62 0 000 12.704 2.327 2.327 0 001.493 1.29 54.921 54.921 0 0018.348 0 2.328 2.328 0 001.493-1.29 17.62 17.62 0 000-12.704zm-6.97 6.749c-2.042 1.165-3.087 1.782-5.06 2.937a.468.468 0 01-.693-.409c-.054-2.34-.054-3.51 0-5.85a.47.47 0 01.693-.412c1.973 1.156 3.017 1.774 5.06 2.94a.454.454 0 010 .794z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgYoutubeIcon;
